import * as types from '../../../../../constants/ActionNameConstants';

const INITIAL_STATE = {
    cgaSearchValue: '',
    rowsPerPage: 10,
    currentPage: 0,
    filterClientData: '',
    filterFilesStatusData: [],
    isFilterApplied: false,
    sortField: 'CreatedOn',
    sortOrder: 0,
};

const CgaFileStatesReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.UPDATE_CGA_FILE_STATES:
            return { ...state, ...action.payload };
        case types.RESET_CGA_FILE_STATES:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default CgaFileStatesReducer;